import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSort, faSortDown, faSortUp } from "@fortawesome/pro-solid-svg-icons";

type SortButtonArgs = {
  setSortBy: () => void;
  sortDirection: "asc" | "desc";
  setSortDirection?: (direction: "asc" | "desc") => void;
  active: boolean;
  label?: string;
};

export default function SortButton({
  setSortBy,
  sortDirection,
  setSortDirection,
  active,
  label,
}: SortButtonArgs) {
  function onSort(e) {
    e.preventDefault();

    setSortBy();
    setSortDirection?.(sortDirection === "asc" ? "desc" : "asc");
  }

  return (
    <button
      type="button"
      className="flex items-center gap-1 hover:cursor-pointer"
      onClick={onSort}
    >
      {label}
      {active ? (
        <FontAwesomeIcon
          icon={sortDirection === "asc" ? faSortUp : faSortDown}
        />
      ) : (
        <FontAwesomeIcon icon={faSort} className="text-muted" />
      )}
    </button>
  );
}
